<template>
    <div class="page_header">
        <img class="back" v-if="hasBack" src="/static/images/user/back.png" @click="back">
        <img class="logo" src="/static/images/user/logo.png">
        <span class="name">陆家嘴白领艺术中心</span>
    </div>
</template>
<script>
export default {
    props:['hasBack'],
    data(){
        return {};
    },
    methods:{
        back(){
            this.$router.back();
        }
    }
}
</script>




// WEBPACK FOOTER //
// src/components/header.vue